module.exports = __webpack_public_path__ + "static/media/purple-flower.0ab949ed.jpg";